/**
 * The city page slugs the router needs, in its own module so the routes do
 * not pull every city's copy (cityLocations.ts) into the main bundle.
 * citySlugs.test.ts keeps these equal to the slugs in cityLocations.ts.
 */

export const EN_CITY_SLUGS_EXTENDED = [
  'london',
  'manchester',
  'birmingham',
  'leeds',
  'glasgow',
  'edinburgh',
  'liverpool',
  'bristol',
  'sheffield',
  'belfast',
  'leicester',
  'coventry',
  'newcastle',
  'southampton',
  'cardiff',
  'new-york',
  'los-angeles',
  'chicago',
  'houston',
  'phoenix',
  'philadelphia',
  'san-antonio',
  'san-diego',
  'dallas',
  'austin',
  'boston',
  'seattle',
  'miami',
  'washington-dc',
  'sydney',
  'melbourne',
  'brisbane',
  'perth',
  'adelaide',
  'johannesburg',
  'cape-town',
  'durban',
] as const;

export const PL_CITY_SLUGS = [
  'warszawa',
  'krakow',
  'lodz',
  'wroclaw',
  'poznan',
  'gdansk',
  'szczecin',
  'bydgoszcz',
  'lublin',
  'katowice',
  'bialystok',
  'gdynia',
  'czestochowa',
  'radom',
  'sosnowiec',
  'torun',
  'kielce',
  'rzeszow',
  'gliwice',
  'zabrze',
  'olsztyn',
  'bielsko-biala',
  'bytom',
  'zielona-gora',
  'rybnik',
  'ruda-slaska',
  'opole',
  'tychy',
  'gorzow-wielkopolski',
  'dabrowa-gornicza',
] as const;

export const DE_CITY_SLUGS = [
  'berlin',
  'muenchen',
  'hamburg',
  'koeln',
  'frankfurt',
  'stuttgart',
  'duesseldorf',
  'leipzig',
  'dortmund',
  'essen',
] as const;

export const IT_CITY_SLUGS = [
  'roma',
  'milano',
  'napoli',
  'torino',
  'bologna',
  'firenze',
] as const;

export const ES_CITY_SLUGS = [
  'madrid',
  'barcelona',
  'valencia',
  'sevilla',
  'bilbao',
  'zaragoza',
] as const;

export const CS_CITY_SLUGS = [
  'praha',
  'brno',
  'ostrava',
  'plzen',
  'olomouc',
] as const;

export const PT_BR_CITY_SLUGS = [
  'sao-paulo',
  'rio-de-janeiro',
  'belo-horizonte',
  'brasilia',
  'porto-alegre',
] as const;

export const NL_CITY_SLUGS = [
  'amsterdam',
  'rotterdam',
  'den-haag',
  'utrecht',
  'eindhoven',
] as const;

export const HU_CITY_SLUGS = [
  'budapest',
  'debrecen',
  'szeged',
] as const;

export const LT_CITY_SLUGS = [
  'vilnius',
  'kaunas',
  'klaipeda',
] as const;

export const RO_CITY_SLUGS = [
  'bucuresti',
  'cluj-napoca',
  'timisoara',
  'iasi',
] as const;
